import { render } from "./GanttChartComponent.vue?vue&type=template&id=5087d71c&scoped=true"
import script from "./GanttChartComponent.vue?vue&type=script&lang=js"
export * from "./GanttChartComponent.vue?vue&type=script&lang=js"

import "./GanttChartComponent.vue?vue&type=style&index=0&id=5087d71c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5087d71c"]])

export default __exports__